import { getUserBinanceAccountInfo, logOutUser } from "../../services/rashTradeServices";
import { parisfyData } from "../../utils/common-functions";
import { errorToastify } from "../../utils/Toastify";
import {
    LOGIN_USER,
    LOGOUT_USER,
    TOGGLE_SPINNER_STATE,
    USER_BINANCE_ACCOUNT_INFO
} from "./constants";

export const getUserBinanceAccountInfoAction = () => async (dispatch, getState) => {
    const { userInfo } = parisfyData({
        ...getState().persistedReducer
    });
    dispatch({ type: TOGGLE_SPINNER_STATE, payload: true });
    try {
        const { accountInfo, openPositionsList } = await getUserBinanceAccountInfo();
        userInfo.balanceDetails = accountInfo;
        userInfo.openPositionsList = openPositionsList;
        dispatch({ type: USER_BINANCE_ACCOUNT_INFO, payload: userInfo });
        return dispatch({ type: TOGGLE_SPINNER_STATE, payload: false });
    } catch (error) {
        errorToastify(
            error?.response?.data?.message?.split(",")[0] || "Failed to get user Binance Info!"
        );
        return dispatch({ type: TOGGLE_SPINNER_STATE, payload: false });
    }
};
export const loginUserAction =
    ({ accessToken, accountName }) =>
    async (dispatch, getState) => {
        const { userInfo } = parisfyData({
            ...getState().persistedReducer
        });
        userInfo.accountInfo = {
            accessToken,
            accountName
        };
        dispatch({ type: LOGIN_USER, payload: userInfo });
    };
export const logOutUserAction = () => async (dispatch, getState) => {
    const { userInfo } = parisfyData({
        ...getState().persistedReducer
    });
    const logOutResp = await logOutUser();
    userInfo.accountInfo = {
        accountName: ""
    };
    dispatch({ type: LOGOUT_USER, payload: userInfo });
};
